import { render, staticRenderFns } from "./aiBookTaskTwo.vue?vue&type=template&id=776b5c94&scoped=true&"
import script from "./aiBookTaskTwo.vue?vue&type=script&lang=js&"
export * from "./aiBookTaskTwo.vue?vue&type=script&lang=js&"
import style0 from "./aiBookTaskTwo.vue?vue&type=style&index=0&id=776b5c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b5c94",
  null
  
)

export default component.exports